import CustomSelect from '../shared/customselect.js';

export const FREQUENCY_OPTIONS = {
  annually: 'annually',
  monthly: 'monthly',
  once: 'once',
};

/**
 *
 * @param {object} props
 * @param {string} props.value
 * @param {(frequency: string) => void} props.onChange
 */
export default function FrequencySelector({ value, onChange }) {
  return (
    <CustomSelect
      options={FREQUENCY_OPTIONS}
      value={value}
      onChange={onChange}
    />
  );
}
